<template>
	<div>
		<v-toolbar flat class="elevation-0 transparent">
			<v-toolbar-title>Permisssions</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-combobox
				v-model="selectedCategories"
				:items="permissionsCategories"
				label="Filter category"
				multiple
				chips
				style="width: 40rem; flex-grow: 0"
			></v-combobox>
		</v-toolbar>

		<v-data-table
			:headers="headers"
			:items="filteredPermissionsByCategories"
			item-key="_id"
			:loading="loading"
			:rows-per-page-items="[10]"
			class="elevation-1"
		>
			<template v-slot:items="props">
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.description }}</td>
				<td>{{ format(props.item.category) }}</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ACTION_NOTIFICATIONS_ERROR, STORE_NOTIFICATIONS_NAME } from '@/store_constants/notifications';
import { GETTER_ALL_PERMISSIONS, STORE_PERMISSIONS_NAME } from '@/store_constants/permissions';
import { GETTER_USER_PERMISSIONS, STORE_USER_NAME } from '@/store_constants/user';

export default {
	data() {
		return {
			filteredOwnPermissons: [],
			loading: true,
			headers: [
				{
					text: 'Name',
					value: 'name'
				},
				{
					text: 'Description',
					value: 'description'
				},
				{
					text: 'Category',
					value: 'category'
				}
			],
			selectedCategories: [],
			permissionsCategories: []
		};
	},
	async created() {
		this.filteredOwnPermissons = this.filterOwnPermissions();
		this.permissionsCategories = this.getPermissionsCategories();

		this.loading = false;
	},
	computed: {
		...mapGetters(STORE_PERMISSIONS_NAME, {
			allPermissions: GETTER_ALL_PERMISSIONS,
			userPermissions: GETTER_USER_PERMISSIONS
		}),
		...mapGetters(STORE_USER_NAME, {
			userPermissions: GETTER_USER_PERMISSIONS
		}),
		filteredPermissionsByCategories() {
			if (this.selectedCategories.length === 0) return this.filteredOwnPermissons;

			const categories = this.selectedCategories.map(category => category.value);
			return this.filteredOwnPermissons.filter(permission => categories.includes(permission.category));
		}
	},
	methods: {
		...mapActions(STORE_NOTIFICATIONS_NAME, {
			error: ACTION_NOTIFICATIONS_ERROR
		}),
		filterOwnPermissions() {
			const ownPermissionsIds = this.userPermissions.map(permission => permission._id);
			return this.allPermissions.filter(permission => ownPermissionsIds.includes(permission._id));
		},
		getPermissionsCategories() {
			const categories = this.filteredOwnPermissons.map(permission => permission.category);
			return categories.map(category => ({ text: this.format(category), value: category }));
		},
		format(string) {
			const words = string.split('_');
			const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
			return formattedWords.join(' ');
		}
	}
};
</script>
